import React, { useState, useRef, useEffect } from "react";
import styles from "./CreateStudents.module.scss";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CreateNewsHeader from "../../../Molecules/NewsAndEvents/CreateNewsHeader";
import folderIcon from "../../../../assets/Imagess/folderICon.svg";
import userIcon from "../../../../assets/Imagess/userinputicon.svg";
import CustomSelect from "../../../Atoms/forms/customSelect/CustomSelect";
import { useMutation } from "react-query";
import axios from "axios";
import { API_URL, securityHeaders } from "../../../../Constants";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import DatePicker from "react-datepicker";
import calendar from "../../../../assets/Imagess/calenderVector.svg";
import "../../../../styles/Quill.css";
import { useFetchDropDownTypes } from "../../../../Hooks/Settings";
import moment from "moment";
import { useFetchAlumniStudentById } from "../../../../Hooks/Alumni";
import TextInput from "../../../Atoms/Inputs/TextInput";
import { useToast } from "../../../Molecules/Custom/CustomToaster/Toast";
import { useFetchDegrees } from "../../../../Hooks/Programs";
import Loader from "../../../Molecules/Loader/Loader";

const UpdateStudent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const { data: genders } = useFetchDropDownTypes(2);
  const { data: nationalities } = useFetchDropDownTypes(3);
  const { data: degrees } = useFetchDegrees(100, 1);
  const { data: student, isLoading, refetch } = useFetchAlumniStudentById(id);
  const customizedToast = useToast();

  const calendarIcon = (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 20956">
        <path
          id="Vector"
          d="M5.43428 0C5.89173 0 6.26256 0.356629 6.26256 0.79655V2.40335C6.99725 2.38964 7.82078 2.38964 8.74737 2.38964H13.1648C14.0914 2.38964 14.9149 2.38964 15.6496 2.40335V0.79655C15.6496 0.356629 16.0204 0 16.4779 0C16.9353 0 17.3062 0.356629 17.3062 0.79655V2.47382C18.8957 2.59623 19.9393 2.89665 20.7059 3.63393C21.4726 4.37121 21.785 5.37475 21.9122 6.90341L21.9999 7.69996H1.01701H0V6.90341C0.12728 5.37475 0.439668 4.37121 1.20631 3.63393C1.97296 2.89665 3.01647 2.59623 4.60601 2.47382V0.79655C4.60601 0.356629 4.97684 0 5.43428 0Z"
          fill="#A9A7A7"
        />
        <path
          id="Vector_2"
          d="M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z"
          fill="#A9A7A7"
        />
      </g>
    </svg>
  );

  useEffect(() => {
    if (!isEmpty(id) && undefined !== id) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(student)) {
      const studentData = student?.data;
      formikRef.current.setValues({
        name: studentData.alumniName_EN || "",
        nameAr: studentData.alumniName_AR || "",
        nationality: studentData.nationalityId || "",
        gender: studentData.genderId || "",
        degree: studentData.degreeId || "",
        gradutionDate: studentData.graduationDate
          ? new Date(studentData.graduationDate)
          : new Date(),
      });
    }
  }, [student]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Event name is required"),
    nameAr: Yup.string().required("Arabic event name is required"),
    nationality: Yup.string().required("Nationality is required"),
    gradutionDate: Yup.date().required("Posted date is required"),
    gender: Yup.string().required("Gender is required"),
    degree: Yup.string().required("Degree is required"),
  });

  const createStudent = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Alumni/Alumni`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      customizedToast.open(
        id ? 'تم تحديث الطالب بنجاح' : 'تم إنشاء الطالب بنجاح'
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append("AlumniName_EN", values.name);
    formData.append("AlumniName_AR", values.nameAr);
    formData.append("NationalityId", values.nationality);
    formData.append("GenderId", values.gender);
    formData.append("DegreeId", values.degree);
    formData.append(
      "GraduationDate",
      moment(values.gradutionDate).format("YYYY-MM-DD")
    );
    const alumniId = id ? id : "00000000-0000-0000-0000-000000000000";
    formData.append("AlumniId", alumniId);
    createStudent.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (
    isLoading ||
    isEmpty(degrees) ||
    isEmpty(nationalities) ||
    isEmpty(genders)
  ) {
    <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={id ? 'تحديث الطالب' : 'إنشاء طالب'}
        />
      </div>{' '}
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            name: student?.data.alumniName_EN || '',
            nameAr: student?.data.alumniName_AR || '',
            nationality: student?.data.nationalityId || '',
            gender: student?.data.genderId || '',
            degree: student?.data.degreeId || '',
            gradutionDate: student?.data.graduationDate
              ? new Date(student?.data.graduationDate)
              : '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <div className={styles['steps']}>
                <div className={styles['step-container']}>
                  <TextInput
                    label="Name"
                    placeholder="Enter Name"
                    icon={userIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.name}
                    touched={touched.name}
                    value={values.name}
                    name="name"
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                  <CustomSelect
                    label="Program"
                    placeholder="Select Program"
                    icon={calendar}
                    style={{ width: '100%' }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ height: '62px', marginTop: '4px' }}
                    value={values.degree}
                    touched={touched.degree}
                    errors={errors.degree}
                    onChange={(e) => setFieldValue('degree', e.value)}
                    options={degrees?.data?.items?.map((option) => ({
                      value: option.degreeId,
                      text: option.degreeNameEn,
                    }))}
                  />
                </div>
                <div className={`${styles['step-container']} ${styles['rtl']}`}>
                  <TextInput
                    label="الاسم"
                    placeholder="أدخل الاسم"
                    icon={userIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{
                      padding: '0px',
                      justifyContent: 'flex-start',
                    }}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    value={values.nameAr}
                    name="nameAr"
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                </div>
                <div
                  className={styles['step-container']}
                  style={{ marginTop: '26px' }}
                >
                  <div className={styles['step-row']}>
                    <div
                      className={styles['add-icon-container']}
                      style={{ width: '100%' }}
                    >
                      <label>Graduation Date</label>
                      <DatePicker
                        placeholderText="Enter Graduation Date"
                        showIcon
                        selected={values.gradutionDate}
                        onChange={(date) =>
                          setFieldValue('gradutionDate', date)
                        }
                        className={
                          errors.gradutionDate && touched.gradutionDate
                            ? styles['date-input-error']
                            : styles['date-input']
                        }
                        dateFormat="yyyy-MM-dd"
                        icon={calendarIcon}
                        calendarIconClassname={styles['icon']}
                        maxDate={new Date()}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={styles['step-container']}
                  style={{ marginTop: '26px' }}
                >
                  <div className={styles['step-row']}>
                    <CustomSelect
                      label="Gender"
                      placeholder="Select Gender"
                      icon={userIcon}
                      style={{ width: '100%' }}
                      iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                      dropdownStyle={{ height: '62px', marginTop: '4px' }}
                      value={values.gender}
                      touched={touched.gender}
                      errors={errors.gender}
                      onChange={(e) => setFieldValue('gender', e.value)}
                      options={genders?.data?.map((option) => ({
                        value: option.value,
                        text: option.text_EN,
                      }))}
                    />
                    <CustomSelect
                      label="Nationality"
                      placeholder="Select Nationality"
                      icon={userIcon}
                      style={{ width: '100%' }}
                      iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                      dropdownStyle={{ height: '62px', marginTop: '4px' }}
                      value={values.nationality}
                      touched={touched.nationality}
                      errors={errors.nationality}
                      onChange={(e) => setFieldValue('nationality', e.value)}
                      options={nationalities?.data?.map((option) => ({
                        value: option.value,
                        text: option.text_EN,
                      }))}
                    />
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateStudent;
